import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMediaIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 32,
	viewBox: "0 0 40 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 32,
			rx: 4,
			fill: "#76ec71"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_828_13162)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M23.75 13.375C23.75 13.6734 23.6315 13.9595 23.4205 14.1705C23.2095 14.3815 22.9234 14.5 22.625 14.5C22.3266 14.5 22.0405 14.3815 21.8295 14.1705C21.6185 13.9595 21.5 13.6734 21.5 13.375C21.5 13.0766 21.6185 12.7905 21.8295 12.5795C22.0405 12.3685 22.3266 12.25 22.625 12.25C22.9234 12.25 23.2095 12.3685 23.4205 12.5795C23.6315 12.7905 23.75 13.0766 23.75 13.375ZM29.75 9.25V21.25V22.75C29.75 23.1478 29.592 23.5294 29.3107 23.8107C29.0294 24.092 28.6478 24.25 28.25 24.25H11.75C11.3522 24.25 10.9706 24.092 10.6893 23.8107C10.408 23.5294 10.25 23.1478 10.25 22.75V19.75V9.25C10.25 8.85218 10.408 8.47064 10.6893 8.18934C10.9706 7.90804 11.3522 7.75 11.75 7.75H28.25C28.6478 7.75 29.0294 7.90804 29.3107 8.18934C29.592 8.47064 29.75 8.85218 29.75 9.25ZM28.25 19.4406V9.25H11.75V17.9406L15.1906 14.5C15.473 14.2217 15.8536 14.0658 16.25 14.0658C16.6464 14.0658 17.027 14.2217 17.3094 14.5L21.5 18.6906L23.4406 16.75C23.723 16.4717 24.1036 16.3158 24.5 16.3158C24.8964 16.3158 25.277 16.4717 25.5594 16.75L28.25 19.4406Z",
				fill: "#0f172b"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_828_13162",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white",
				transform: "translate(8 4)"
			})
		}) })
	]
});
export default SvgMediaIcon;
